import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'app',
  initialState: {
    error: null,
    bottomSheetOpen: false,
    legends: {}
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setLegendColors: (state, action) => {
      state.legends = action.payload;
    },
    setBottomSheetOpen: (state, action) => {
      state.bottomSheetOpen = action.payload;
    },
  },
});

export default slice.reducer;

export const setError = (payload: string | null) => ({
  type: 'app/setError',
  payload,
});
export const setBottomSheetOpen = (payload: boolean) => ({
  type: 'app/setBottomSheetOpen',
  payload,
});
export const setLegendColors = (payload: any) => ({
  type: 'app/setLegendColors',
  payload,
});

